import { message } from 'antd';
import React, { createContext, useContext } from 'react';
import type { MessageInstance } from 'antd/es/message/interface';

// Create a context for the message API
export const MessageContext = createContext<MessageInstance | null>(null);

// Create a provider component
export const MessageProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider value={messageApi}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};

// Create a hook to use the message API
export const useMessageApi = (): MessageInstance => {
  const messageApi = useContext(MessageContext);
  if (!messageApi) {
    throw new Error('useMessageApi must be used within a MessageProvider');
  }
  return messageApi;
};

// Create convenience methods
export const useMessage = () => {
  const messageApi = useMessageApi();

  return {
    success: (content: string) => messageApi.success(content),
    error: (content: string) => messageApi.error(content),
    warning: (content: string) => messageApi.warning(content),
    info: (content: string) => messageApi.info(content),
    loading: (options: Parameters<MessageInstance['loading']>[0]) => messageApi.loading(options),
  };
};
